import Home from './home'
export default [
  {
    path: '/home',
    name: 'home',
    component: Home
  },
  {
    path: '/',
    redirect: '/home'
  }
]



// WEBPACK FOOTER //
// ./src/components/home/home-router.js